(() => {
  const sectionDefinitions = new Map([
    ['technical-data', 'Technische Daten'],
    ['manufacturer-information', 'Herstellerinformation'],
    ['delivery-contents', 'Lieferumfang'],
    ['faq', 'FAQ'],
  ]);

  const sectionAliases = new Map([
    ['technische daten', 'technical-data'],
    ['technische details', 'technical-data'],
    ['technische informationen', 'technical-data'],
    ['spezifikationen', 'technical-data'],
    ['herstellerangabe', 'manufacturer-information'],
    ['herstellerangaben', 'manufacturer-information'],
    ['herstellerinformation', 'manufacturer-information'],
    ['herstellerinformationen', 'manufacturer-information'],
    ['informationen zum hersteller', 'manufacturer-information'],
    ['lieferumfang', 'delivery-contents'],
    ['im lieferumfang', 'delivery-contents'],
    ['faq', 'faq'],
    ['fragen und antworten', 'faq'],
    ['häufig gestellte fragen', 'faq'],
  ]);

  const normalize = (value) => value.trim().replace(/:$/, '').replace(/\s+/g, ' ').toLocaleLowerCase('de-DE');

  const getSectionKey = (element) => {
    if (/^H[2-6]$/.test(element.tagName)) {
      return sectionAliases.get(normalize(element.textContent || ''));
    }

    if (element.tagName === 'P' && element.children.length === 1 && element.firstElementChild?.tagName === 'STRONG') {
      return sectionAliases.get(normalize(element.textContent || ''));
    }

    return undefined;
  };

  const createAccordion = (key) => {
    const accordion = document.createElement('div');
    accordion.className = 'product__accordion accordion dyn-dropshop-accordion';

    const details = document.createElement('details');
    const summary = document.createElement('summary');
    const titleWrap = document.createElement('div');
    const title = document.createElement('h2');
    const caret = document.createElement('span');
    const content = document.createElement('div');

    titleWrap.className = 'summary__title';
    title.className = 'h4 accordion__title dyn-dropshop-accordion__title';
    title.textContent = sectionDefinitions.get(key);
    caret.className = 'dyn-dropshop-accordion__caret';
    caret.setAttribute('aria-hidden', 'true');
    caret.textContent = '⌄';
    content.className = 'accordion__content rte dyn-dropshop-accordion__content';

    titleWrap.append(title);
    summary.append(titleWrap, caret);
    details.append(summary, content);
    accordion.append(details);

    return { accordion, content };
  };

  const enhanceDescription = (description) => {
    if (description.dataset.dropshopAccordionsReady === 'true') return;

    const sectionHeadings = Array.from(description.querySelectorAll('h2, h3, h4, h5, h6, p')).filter((element) =>
      getSectionKey(element),
    );
    if (!sectionHeadings.length) return;

    const fragment = document.createDocumentFragment();
    const sections = new Map();

    const introductoryRange = document.createRange();
    introductoryRange.setStart(description, 0);
    introductoryRange.setEndBefore(sectionHeadings[0]);
    fragment.append(introductoryRange.cloneContents());

    sectionHeadings.forEach((heading, index) => {
      const key = getSectionKey(heading);
      if (!sections.has(key)) sections.set(key, createAccordion(key));

      const contentRange = document.createRange();
      contentRange.setStartAfter(heading);

      const nextHeading = sectionHeadings[index + 1];
      if (nextHeading) {
        contentRange.setEndBefore(nextHeading);
      } else {
        contentRange.setEnd(description, description.childNodes.length);
      }

      sections.get(key).content.append(contentRange.cloneContents());
    });

    sectionDefinitions.forEach((_label, key) => {
      const section = sections.get(key);
      if (section?.content.textContent.trim() || section?.content.querySelector('img, video, table, ul, ol')) {
        fragment.append(section.accordion);
      }
    });

    description.replaceChildren(fragment);
    description.dataset.dropshopAccordionsReady = 'true';
  };

  const initialize = (root = document) => {
    root.querySelectorAll('.dyn-dropshop-description').forEach(enhanceDescription);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
